import classNames from 'classnames/bind'


export const Tab = ({ isActive, children }) => (
  <div className={classNames({
    'tabs-content-item': true,
    'is-active': isActive
  })}>
    {children}
  </div>
)

export const TabLink = props => (
  <li
    className={classNames({
      'is-active': props.isActive
    })}
    onClick={props.onClick}
  >
    <a><span>{props.title}</span></a>
  </li>
)




// WEBPACK FOOTER //
// ./components/uiLib/Tabs/index.js